import request from '@/utils/request'; // 回访
// 列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/insert',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/update',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/complaintReturn/delete',
    method: 'post',
    data: data
  });
} // 查询角色权限

export function getLoginRoleIsSuper(data) {
  return request({
    url: '/userservice/api/user/getLoginRoleIsSuper',
    method: 'post',
    data: data
  });
}